import { useContext } from 'react';
import { AmplitudeContext } from "./AmplitudeContext";
function useAmplitude() {
  var context = useContext(AmplitudeContext);
  if (context === undefined) {
    throw new Error('useAmplitude must be used within an AmplitudeProvider');
  }
  return context;
}
export default useAmplitude;